<div class="content-card lib-elevation-1">
  <nav class="lib-nav">
    <lib-icon [name]="icon"></lib-icon>
    <span class="mr-1 bold">{{ title }}</span> <span class="subtitle text-warm-charcoal">{{titleDetails}}</span>
    <span [hidden]="!badge" class="lib-badge">{{ badge }}</span>
  </nav>
  <div class="content">
    <p *ngIf="subtitle">{{ subtitle }}</p>
    <ng-content></ng-content>
  </div>
</div>